import React, { createContext, useContext, useState } from "react";

const DateScrollContext = createContext();

export function DateScrollProvider({ children }) {
  const [scrollToDateFn, setScrollToDateFn] = useState(null);
  const [activeDate, setActiveDate] = useState(null);

  return (
    <DateScrollContext.Provider value={{ scrollToDateFn, setScrollToDateFn, activeDate, setActiveDate }}>
      {children}
    </DateScrollContext.Provider>
  );
}

export function useDateScroll() {
  return useContext(DateScrollContext);
}
